import { render, staticRenderFns } from "./EditPermisosEmpresaUserModal.vue?vue&type=template&id=46d2c14c&scoped=true"
import script from "./EditPermisosEmpresaUserModal.vue?vue&type=script&lang=js"
export * from "./EditPermisosEmpresaUserModal.vue?vue&type=script&lang=js"
import style0 from "./EditPermisosEmpresaUserModal.vue?vue&type=style&index=0&id=46d2c14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2c14c",
  null
  
)

export default component.exports